import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ErrorBoundary from "./components/ErrorBoundary";
import AuthCallback from "./pages/AuthCallback";
import Login from "./pages/Login";
import AgentsList from "./pages/AgentsList";
import AgentDetail from "./pages/AgentDetail";
import Widget from "./pages/Widget";

// AppRouter handles session_id detection synchronously during render
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id SYNCHRONOUSLY during render
  // This prevents race conditions by processing new session_id FIRST
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/widget/:agentId" element={<Widget />} />

      {/* Protected Routes */}
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <Navigate to="/dashboard/agents" replace />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/dashboard/agents" 
        element={
          <ProtectedRoute>
            <AgentsList />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/dashboard/agents/:id" 
        element={
          <ProtectedRoute>
            <AgentDetail />
          </ProtectedRoute>
        } 
      />

      {/* Default redirect */}
      <Route path="*" element={<Login />} />
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </AuthProvider>
      </div>
    </ErrorBoundary>
  );
}

export default App;
